const data = [
    {
        url: 'https://www.bbc.com/news/live/world-us-canada-64189582',
        title: "McCarthy set to lose 13th Speaker vote but some rebels turn - BBC",
        country: 'uk',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam ea voluptatibus quos, veritatis repellat est vero optio minima tempore ullam facilis iure nesciunt accusamus aperiam. Nobis dicta quod fuga! Qui enim dolorem quia cum maxime.',
        urlToImage: 'https://m.files.bbci.co.uk/modules/bbc-morph-news-waf-page-meta/5.3.0/bbc_news_logo.png',
        author: 'jhon doe',
        publishedAt: '12/2/2005 | 2:30 pm'
    },
    {
        url: 'https://www.dailymail.co.uk/tvshowbiz/article-11607887/Terminator-actor-Earl-Boen-dies-81-Hollywood-vet-passed-away-Hawaii.html',
        title: "Terminator actor Earl Boen dies at 81: The Hollywood vet passed away in Hawaii - Daily Mail",
        country: 'uk',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam ea voluptatibus quos, veritatis repellat est vero optio minima tempore ullam facilis iure nesciunt accusamus aperiam. Nobis dicta quod fuga! Qui enim dolorem quia cum maxime.',

        urlToImage: 'https://i.dailymail.co.uk/1s/2023/01/06/20/66281465-0-image-a-23_1673035693790.jpg',
        author: 'jhon doe',
        publishedAt: '12/2/2005 | 2:30 pm'
    },
    {
        url: 'https://www.theguardian.com/uk-news/2023/jan/06/prince-harry-saw-red-mist-in-william-during-alleged-attack',
        title: "Prince Harry saw ‘red mist’ in William during brother’s alleged attack - The Guardian",
        country: 'uk',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam ea voluptatibus quos, veritatis repellat est vero optio minima tempore ullam facilis iure nesciunt accusamus aperiam. Nobis dicta quod fuga! Qui enim dolorem quia cum maxime.',

        urlToImage: 'https://i.guim.co.uk/img/media/8280039ece5960a6dd04dd544d8a29428e163b2a/0_70_1536_922/master/1536.jpg?width=1200&height=630&quality=85&auto=format&fit=crop&overlay-align=bottom%2Cleft&overlay-width=100p&overlay-base64=L2ltZy9zdGF0aWMvb3ZlcmxheXMvdGctZGVmYXVsdC5wbmc&enable=upscale&s=95e633d17750ba4ecb20b1e9d6f79269',
        author: 'jhon doe',
        publishedAt: '12/2/2005 | 2:30 pm'
    },
    {
        url: 'https://www.bbc.com/news/entertainment-arts-64185688',
        title: "Prince Harry's Spare: Have leaks helped or hindered his book's PR strategy? - BBC",
        country: 'uk',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam ea voluptatibus quos, veritatis repellat est vero optio minima tempore ullam facilis iure nesciunt accusamus aperiam. Nobis dicta quod fuga! Qui enim dolorem quia cum maxime.',

        urlToImage: 'https://ichef.bbci.co.uk/news/1024/branded_news/EE68/production/_128223016_cropharry.jpg',
        author: 'jhon doe',
        publishedAt: '12/2/2005 | 2:30 pm'
    },
    {
        url: 'https://www.skysports.com/football/news/11095/12781326/romeo-beckham-brentford-b-complete-loan-signing-of-david-beckhams-son-from-inter-miami',
        title: "Romeo Beckham: Brentford B complete loan signing of David Beckham's son from Inter Miami - Sky Sports",
        country: 'uk',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam ea voluptatibus quos, veritatis repellat est vero optio minima tempore ullam facilis iure nesciunt accusamus aperiam. Nobis dicta quod fuga! Qui enim dolorem quia cum maxime.',

        urlToImage: 'https://e0.365dm.com/23/01/1600x900/skysports-romeo-beckham-brentford_6016493.jpg?20230106191505',
        author: 'jhon doe',
        publishedAt: '12/2/2005 | 2:30 pm'
    },
    {
        url: 'https://www.lequipe.fr/Football/Actualites/La-compo-du-psg-a-chateauroux-bitshiabu-zaire-emery-et-gharbi-titulaires/1373217',
        title: "La compo du PSG à Châteauroux : Bitshiabu, Zaïre-Emery et Gharbi titulaires - L'Équipe",
        country: 'fr',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam ea voluptatibus quos, veritatis repellat est vero optio minima tempore ullam facilis iure nesciunt accusamus aperiam. Nobis dicta quod fuga! Qui enim dolorem quia cum maxime.',

        urlToImage: 'https://medias.lequipe.fr/img-video-cover/1500000001732218/640/0',
        author: 'jhon doe',
        publishedAt: '12/2/2005 | 2:30 pm'
    },
    {
        url: 'https://www.francebleu.fr/infos/societe/la-poste-va-commencer-a-supprimer-les-tournees-quotidiennes-des-facteurs-7641414',
        title: "La Poste : découvrez les 68 sites où les facteurs ne passeront plus tous les jours, à partir du mois de mars - France Bleu",
        country: 'fr',
        author: 'jhon doe',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam ea voluptatibus quos, veritatis repellat est vero optio minima tempore ullam facilis iure nesciunt accusamus aperiam. Nobis dicta quod fuga! Qui enim dolorem quia cum maxime.',

        publishedAt: '12/2/2005 | 2:30 pm',
        urlToImage: 'https://www.francebleu.fr/s3/cruiser-production/2023/01/9a26de86-60a0-4e52-9214-a11586239449/1200x680_080-hl-fscheiber-1095662.jpg'
    },
    {
        url: 'https://www.lemonde.fr/international/live/2023/01/06/guerre-en-ukraine-en-direct-nouveaux-affrontements-en-depit-du-cessez-le-feu-unilateral-decide-par-moscou_6156818_3210.html',
        title: "Guerre en Ukraine, en direct : duels d'artillerie à Bakhmout, dans l'Est, presque vidée de ses habitants - Le Monde",
        country: 'fr',
        author: 'jhon doe',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam ea voluptatibus quos, veritatis repellat est vero optio minima tempore ullam facilis iure nesciunt accusamus aperiam. Nobis dicta quod fuga! Qui enim dolorem quia cum maxime.',

        publishedAt: '12/2/2005 | 2:30 pm',
        urlToImage: 'https://img.lemde.fr/2023/01/06/102/0/4000/2000/1440/720/60/0/36f7d1a_1673035360780-539401.jpg'
    },
    {
        url: 'https://www.thechronicle.com.au/news/world/webb-telescope-sheds-light-on-the-early-universe/video/a1ea4dc471274a667a2c48694a08f8a0',
        title: "Webb Telescope Sheds Light on the Early Universe - Toowoomba Chronicle",
        country: 'au',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam ea voluptatibus quos, veritatis repellat est vero optio minima tempore ullam facilis iure nesciunt accusamus aperiam. Nobis dicta quod fuga! Qui enim dolorem quia cum maxime.',

        author: 'jhon doe',
        publishedAt: '12/2/2005 | 2:30 pm',
        urlToImage: 'https://content.api.news/v3/images/bin/1951bcb90ccb48f0674ebe1ccc07c2a6'
    },
    {
        url: 'https://www.healio.com/news/primary-care/20230106/pcps-often-order-lowvalue-prostate-cancer-screenings-study-finds',
        title: "PCPs often order low-value prostate cancer screenings, study finds - Healio",
        country: 'au',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam ea voluptatibus quos, veritatis repellat est vero optio minima tempore ullam facilis iure nesciunt accusamus aperiam. Nobis dicta quod fuga! Qui enim dolorem quia cum maxime.',

        author: 'jhon doe',
        publishedAt: '12/2/2005 | 2:30 pm',
        urlToImage: 'https://www.healio.com/~/media/images/fscss/i3wyanokecdncom/healio_safe_image.png'
    },
    {
        url: 'https://www.cnet.com/science/space/nasa-is-pumped-about-2023-here-are-all-the-reasons-why/',
        title: "NASA's Pumped About 2023: Here's Why - CNET",
        country: 'au',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam ea voluptatibus quos, veritatis repellat est vero optio minima tempore ullam facilis iure nesciunt accusamus aperiam. Nobis dicta quod fuga! Qui enim dolorem quia cum maxime.',

        author: 'jhon doe',
        publishedAt: '12/2/2005 | 2:30 pm',
        urlToImage: 'https://www.cnet.com/a/img/resize/239a94258ace989ac8ac78e4729c7315ea45f171/hub/2022/05/26/89a42880-07c2-475e-a813-c51b3f5e76a3/starliner2return.jpg?auto=webp&fit=crop&height=630&width=1200'
    },
    {
        url: 'https://www.wsj.com/livecoverage/stock-market-news-today-01-06-2023-december-jobs-report-unemployment-rate',
        title: "Stock Market News Today: Dow Climbs Over 700 Points After December Jobs Report - The Wall Street Journal",
        country: 'us',
        author: 'jhon doe',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam ea voluptatibus quos, veritatis repellat est vero optio minima tempore ullam facilis iure nesciunt accusamus aperiam. Nobis dicta quod fuga! Qui enim dolorem quia cum maxime.',
        publishedAt: '12/2/2005 | 2:30 pm',
        urlToImage: 'https://images.wsj.net/im-589547/social'
    },
    {
        url: 'https://www.wsj.com/livecoverage/house-speaker-vote-kevin-mccarthy-gop',
        title: "House Speaker Vote: Watch Live as 13 Republican Holdouts Flip to Kevin McCarthy - The Wall Street Journal",
        country: 'us',
        author: 'jhon doe',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam ea voluptatibus quos, veritatis repellat est vero optio minima tempore ullam facilis iure nesciunt accusamus aperiam. Nobis dicta quod fuga! Qui enim dolorem quia cum maxime.',
        publishedAt: '12/2/2005 | 2:30 pm',
        urlToImage: 'https://images.wsj.net/im-698426/social'
    },
    {
        url: 'https://www.usatoday.com/story/entertainment/celebrities/2023/01/06/jen-shah-sentencing-rhoslc-star-telemarketing-scheme/10989334002/',
        title: "Jen Shah sentencing: Judge gives RHOSLC star 6.5 years for scheme - USA TODAY",
        country: 'us',
        author: 'jhon doe',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam ea voluptatibus quos, veritatis repellat est vero optio minima tempore ullam facilis iure nesciunt accusamus aperiam. Nobis dicta quod fuga! Qui enim dolorem quia cum maxime.',
        publishedAt: '12/2/2005 | 2:30 pm',
        urlToImage: 'https://www.gannett-cdn.com/presto/2023/01/06/USAT/2d4de997-bec7-412b-8260-a6c9d7a3533f-AP_Real_Housewives_Fraud.jpg?auto=webp&crop=1280,720,x0,y384&format=pjpg&width=1200'
    }
]

export default data;